<template>
  <div class="wh100 container">
    <van-popup v-model="pdfShow" position="right" :style="{ width: '100%', height: '100%' }">
      <div class="pdf-view" v-if="pdfShow">
        <div class="tabbar-container">
          <div class="popup-back" @click="pdfClose">
            <van-icon name="arrow-left" />
            返回
          </div>
          {{ fileTitle }}
        </div>
        <v-touch @swipeup="swiperup" @swipedown="swiperdown" @swipeleft="swiperleft" @swiperight="swiperright" style="flex: 1">
          <div class="pdf-c">
            <pdf :page="currentPage" ref="pdf" :src="pdfSrc" @num-pages="pageCount = $event" @page-loaded="currentPage = $event" @loaded="loadPdfHandler"> </pdf>
          </div>
        </v-touch>
        <!--页码-->
        <div class="pdf-page">
          <!--上一页-->
          <span @click="changePdfPage(0)" class="turn">上一页</span>
          {{ currentPage }} / {{ pageCount }}
          <!--下一页-->
          <span @click="changePdfPage(1)" class="turn">下一页</span>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="videoShow" position="right" :style="{ width: '100%', height: '100%' }">
      <div class="video-container">
        <div class="tabbar-container">
          <div class="popup-back" @click="videoClose">
            <van-icon name="arrow-left" />
            返回
          </div>
          {{ fileTitle }}
        </div>
        <video v-if="videoShow" id="videoBank" ref="videoB" :src="videoSrc" style="width: 100%; height: 35%" class="video-js vjs-big-play-centered" controls webkit-playsinline playsinline preload="auto" poster=""></video>
        <div v-if="videoShow" class="face-capture" id="face-capture">
          <video id="video" :width="vwidth" :height="vheight" playsinline webkit-playsinline></video>
          <canvas id="refCanvas" :width="cwidth" :height="cheight"></canvas>
          <p class="contentp">{{ scanTip }}</p>
        </div>
      </div>
      <!-- <iframe
        v-if="videoShow"
        :src="captureFrameSrc"
        name="captureFrame"
        class="captureFrame"
      ></iframe> -->
    </van-popup>

    <div class="tabbar-container">
      <div class="popup-back" @click="Back">
        <van-icon name="arrow-left" />
        返回
      </div>
      课程列表
    </div>
    <van-image width="100%" height="10rem" fit="cover" :src="bxzcmh" />
    <van-field style="background-color: antiquewhite" v-if="BJData && BJData.length > 0" v-model="ClassName" label="选择班级" readonly @click="showBJ = true" placeholder="请选择班级" input-align="right" />
    <div class="middle-container">
      <van-tabs title-active-color="#2D8EFC" color="#2D8EFC" v-model="active">
        <van-tab title="题库练习">
          <van-cell v-if="tkShow" title="模拟练习" @click="startQue" :label="name" value="开始练习" is-link icon="label-o" />
          <van-empty v-else :description="tkMessage" />
        </van-tab>
        <van-tab title="课件学习">
          <div class="middle-tags">
            <van-pull-refresh v-model="Refreshing" @refresh="onRefresh">
              <van-list v-model="Loading" :finished="Finished" finished-text="没有更多了" @load="onListLoad">
                <div class="approve-view" v-for="(item, index) in List" :key="index">
                  <van-cell @click="item.FileType === '视频' ? videoPlay(item) : showPDF(item)" :title="`${index + 1}. ${item.VideoName}`" :value="`${item.CREATE_DATE.split('T')[0]}`">
                    <template #label>
                      <van-tag style="margin-right: 0.5rem" :type="`${item.FileType === '视频' ? 'primary' : 'warning'}`">{{ `${item.FileType}` }}</van-tag>
                      <van-tag v-if="item.FileType === '视频' && item.TimeProgress !== '0'" plain type="primary">{{ `${getJd(parseInt(item.Duration), parseInt(item.TimeProgress))}` }}</van-tag>
                      <van-tag v-if="item.FileType === 'PDF' && item.TimeProgress !== '0'" plain type="warning">已看{{ item.TimeProgress }}页</van-tag>
                    </template>
                  </van-cell>
                </div>
              </van-list>
            </van-pull-refresh>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 练习答题页面 -->
    <van-popup v-model="showQue" position="right" :lock-scroll="false" :style="{ width: '100%', height: '100%' }">
      <que v-if="showQue" :queForm="queForm" @fatherMethod="QueBack" />
    </van-popup>
    <!-- 班级选择 -->
    <van-popup v-model="showBJ" round position="bottom">
      <van-picker title="选择班级" show-toolbar value-key="ClassName" :columns="BJData" @confirm="confirmBJ" @cancel="onCancel" />
    </van-popup>

    <van-overlay :show="addLoading" :custom-style="{ background: 'rgba(0,0,0,0.2)' }">
      <van-loading style="position: absolute; top: calc(50% - 25px); left: calc(50% - 30px)" size="50px" color="#0094ff" vertical text-color="#0094ff">加载中</van-loading>
    </van-overlay>
  </div>
</template>

<script>
require("tracking/build/tracking-min.js");
require("tracking/build/data/face-min.js");
import { Dialog } from "vant";
import pdf from "vue-pdf";
import que from "./que.vue";
export default {
  name: "videoList",
  components: { pdf, que },
  computed: {},
  props: {
    QuesID: {
      type: String,
      require: true,
    },
    name: {
      type: String,
      require: true,
      default: "",
    },
  },
  data() {
    return {
      active: 0,
      tkShow: true,
      tkMessage: "",
      // 班级选择
      ClassName: "",
      ClassID: "",
      showBJ: false,
      BJData: [],
      // 人脸识别
      screenSize: {
        width: window.screen.width,
        height: window.screen.height,
      },
      tracker: null,
      context: null, // canvas上下文
      scanTip: "人脸识别中...", // 提示文字
      vwidth: "277",
      vheight: "277",
      cwidth: "277",
      cheight: "277",
      faceTimeout: null,
      facetime: 0,

      addLoading: false,
      bxzcmh: require("../../assets/icon/bxzcmh.png"),
      // 学习页面
      showQue: false,
      queForm: {
        ClassID: "",
        ClassName: "",
      },
      STID: "",

      // 学习列表
      List: [],
      Loading: false,
      Finished: false,
      Refreshing: false,
      IdCard: localStorage.getItem("IdCard"),
      student: {},
      ReportForm: {
        SubjectID: this.QuesID,
        IdCard: localStorage.getItem("IdCard"),
        PageIndex: 0,
        PageSize: 20,
      },
      // 当日观看历史
      videoHistory: [],

      //视频
      captureFrameSrc: "",
      videoShow: false,
      fileTitle: "",
      videoSrc: "#",
      VideoData: [],
      VideoId: "",

      // PDF
      pdfShow: false,
      pdfSrc: "",
      pageCount: 0,
      currentPage: 0,
    };
  },
  watch: {},
  created() {},
  async mounted() {
    this.addLoading = true;
    setTimeout(() => {
      this.addLoading = false;
    }, 20000);
    const student = await this.$store.dispatch("api/GetSutentById", {
      IdCard: localStorage.getItem("IdCard"),
    });
    if (student.data && student.data.length > 0) {
      this.student = student.data[0];
    }

    const bzRes = await this.$store.dispatch("api/GetTrainClass", {
      IdCard: localStorage.getItem("IdCard"),
      SubjectIDSingle: this.QuesID,
    });
    this.BJData = bzRes.data;
    if (this.BJData.length > 0) {
      this.confirmBJ(this.BJData[0]);
    }

    const data = await this.$store.dispatch("api/getQuesID", {
      SubjectID: this.QuesID,
    });
    if (data.data) {
      this.STID = data.data;
      const QueData = await this.$store.dispatch("api/GetPlanBySubjectID", {
        QuesID: this.STID,
      });
      // 开始答题
      var QD = QueData.data[0];
      this.queForm.QuesID = this.STID;
      //bug修改
      this.queForm.SubjectID = this.QuesID;

      this.queForm.IdCard = this.IdCard;
      this.queForm.CutOffScoresqq = QD.CutOffScores;
      this.queForm.DanNumqq = 10000;
      this.queForm.DanScoreqq = QD.DanScore;
      this.queForm.DuoNumqq = 10000;
      this.queForm.DuoScoreqq = QD.DuoScore;
      this.queForm.PanNumqq = 10000;
      this.queForm.PanScoreqq = QD.PanScore;
      this.queForm.TestTimeqq = QD.TestTime;
    } else {
      this.tkShow = false;
      this.tkMessage = data.message;
    }
    this.addLoading = false;

    //设置video canvas宽高
    const scale = this.screenSize.width / 375;
    this.vwidth = 277 * scale;
    this.vheight = 277 * scale;
    this.cwidth = 277 * scale;
    this.cheight = 277 * scale;
  },
  destroyed() {},
  methods: {
    // 屏幕滑动监听
    swiperup: function () {
      this.changePdfPage(1);
    },
    swiperdown: function () {
      this.changePdfPage(0);
    },
    swiperleft: function () {
      this.changePdfPage(1);
    },
    swiperright: function () {
      this.changePdfPage(0);
    },
    // pdf加载时
    loadPdfHandler() {
      // this.currentPage = 1; // 加载的时候先加载第一页
    },
    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage(val) {
      // console.log(val)
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    },
    async startQue() {
      var IdCard = this.IdCard;
      if (!IdCard) {
        Dialog.confirm({
          message: "未获取到用户信息\n请去【我的-信息完善】中补全身份证",
          showCancelButton: false,
          confirmButtonText: "去完善",
        }).then(() => {
          this.$emit("fatherMethod2");
        });
      } else {
        this.showQue = true;
      }
    },
    onListLoad() {
      this.addLoading = true;
      setTimeout(() => {
        this.addLoading = false;
      }, 20000);

      setTimeout(() => {
        if (this.Refreshing) {
          this.List = [];
          this.Refreshing = false;

          this.ReportForm.PageIndex = 0;
        }

        this.ReportForm.PageIndex = this.ReportForm.PageIndex + 1;

        this.$store
          .dispatch("api/getVideoM", this.ReportForm)
          .then((response) => {
            if (response.success) {
              this.List = this.List.concat(response.rows);
              this.Loading = false;
              this.Finished = false;

              if (this.List.length === response.total) {
                this.Loading = true;
                this.Finished = true;
              }
            } else {
              this.$notify(response.message);
              this.Loading = true;
              this.Finished = true;
            }
            this.addLoading = false;
          })
          .catch((error) => {
            console.log(error);
            this.Loading = true;
            this.Finished = true;
            this.addLoading = false;
          });
      }, 1000);
    },
    onRefresh() {
      // 清空列表数据
      this.Finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.Loading = true;
      this.onListLoad();
    },
    getJd(zsc, sc) {
      if (sc === "0") return "";
      // 已看时常+1大于总时长：已完成
      var moreSc = sc + 1;
      if (moreSc >= zsc) return "已完成";
      return `已看${parseInt((sc / zsc) * 100)}%`;
    },
    showPDF(item) {
      this.fileTitle = item.VideoName;
      this.pdfSrc = item.VideoUrl;
      this.VideoId = item.VideoId;
      this.currentPage = item.TimeProgress === "0" ? 1 : Number(item.TimeProgress);
      this.getNumPages();
      setTimeout(() => {
        this.pdfShow = true;
      }, 500);
    },
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.pdfSrc);
      loadingTask.promise.then((pdf) => {
        this.pageCount = pdf._pdfInfo.numPages;
      });
    },
    async VideoHistory() {
      if (localStorage.getItem("IdCard")) {
        const videoHistory = await this.$store.dispatch("api/VideoHistory", {
          IdCard: localStorage.getItem("IdCard"),
          UPDATETIME: this.$getNowDate("yyyy-mm-dd hh:mm:ss"),
        });
        this.videoHistory = videoHistory.rows;
      }
    },
    async videoPlay(item) {
      // 新员工逻辑过滤
      if (this.student.StudentType == "新员工") {
        await this.VideoHistory();
        //针对三级培训，线上培训每日不得超过10学时s
        //1.将今日学习的学时统计出来
        let todayCourseHour = this.videoHistory.reduce((total, item) => {
          return total + parseFloat(item.VideoHour);
        }, 0);
        console.log("todayCourseHour", todayCourseHour);
        //2.判断今日总学时是否超过10个
        if (todayCourseHour > 10) {
          Dialog.confirm({
            message: "线上培训每日不得超过10学时",
            showCancelButton: false,
            confirmButtonText: "确定",
          });
          return false;
        }
      }
      // this.ClassInfo = JSON.parse(localStorage.getItem("ClassInfo"));
      // this.captureFrameSrc =
      //   "Capture?ClassID=" +
      //   (this.ClassInfo ? this.ClassInfo.ClassID : "") +
      //   "&IdCard=" +
      //   this.IdCard +
      //   "&VideoId=" +
      //   item.VideoId;

      this.endtype = "";
      this.VideoId = item.VideoId;
      this.fileTitle = item.VideoName;
      this.CourseId = item.CourseId;
      this.videoShow = true;
      this.videoSrc = item.VideoUrl;
      //this.videoSrc = "http://www.bingxinsafe.com/Upload/VideoPx/20220406091119875/%E7%81%AB%E7%81%BE%E9%80%83%E7%94%9F%E8%87%AA%E6%95%91%E6%96%B9%E6%B3%95.mp4"

      // this.$nextTick(() => {
      //   var iframe = $("[name='captureFrame']")[0];
      //   if (iframe.attachEvent) {
      //     // 兼容IE写法
      //     iframe.attachEvent("onload", function () {
      //       setTimeout(() => {
      //         $("[name='captureFrame']")[0].contentWindow.doCapture();
      //       }, 8000);
      //     });
      //   } else {
      //     iframe.onload = function () {
      //       setTimeout(() => {
      //         $("[name='captureFrame']")[0].contentWindow.doCapture();
      //       }, 8000);
      //     };
      //   }
      // });

      var that = this;
      var resetTime = 0; // 拖动后重置播放时间
      var curTime = 0; // 当前播放时间
      this.setIntervalPlay = null;

      if (item.Duration === item.TimeProgress) {
        localStorage.setItem(this.IdCard + item.VideoId + "remTime", 0);
      }

      setTimeout(function () {
        var vd = document.getElementById("videoBank"); //获取video对象

        var getCurTime = localStorage.getItem(that.IdCard + item.VideoId + "remTime"); //获取本地存储
        getCurTime = getCurTime || item.TimeProgress;
        if (getCurTime >= Number(item.Duration)) {
          getCurTime = 0;
        }
        if (getCurTime > 0.1) {
          (curTime = getCurTime), (resetTime = getCurTime);
          //设置缓存的视频进度
          vd.addEventListener("play", function () {
            vd.currentTime = getCurTime;
            that.playVideo();
          });
        } else {
          vd.addEventListener("play", function () {
            that.playVideo();
          });
        }
        vd.addEventListener("pause", function () {
          getCurTime = vd.currentTime;
          that.close();
        });
        var tmpsecond;
        vd.addEventListener("timeupdate", function () {
          var nowsecond = parseInt(vd.currentTime);
          if (nowsecond % 5 === 0 && nowsecond !== tmpsecond) {
            tmpsecond = nowsecond;
            that.AddVideoRecord();
          }
        });
        //视频播放
        vd.play();
        //实时记录缓存进度并阻止快进
        that.setIntervalPlay = setInterval(timer, 100);

        //定时器
        function timer() {
          //并阻止快进
          curTime = vd.currentTime;
          if (curTime - resetTime > 2) {
            vd.currentTime = resetTime;
          } else {
            resetTime = curTime;
          }
          //实时记录缓存进度
          localStorage.setItem(that.IdCard + item.VideoId + "remTime", curTime);
        }

        //vd.addEventListener('pause', function () {

        //})

        vd.addEventListener(
          "ended",
          function () {
            // $("[name='captureFrame']")[0].contentWindow.doCapture();
            //触发记录观看视频次数接口
            that.AddVideoHistory(item, "end");
          },
          false
        );
      }, 500);
    },
    pdfClose() {
      this.pdfShow = false;
      this.AddPdfRecord();
      this.pdfSrc = "";
      this.pageCount = 0;
      this.currentPage = 0;
      var that = this;
      setTimeout(function () {
        that.Refreshing = true;
        that.onRefresh();
      }, 600);
    },
    AddPdfRecord() {
      this.$store
        .dispatch("api/AddVideoRecord", {
          IdCard: this.IdCard,
          VideoId: this.VideoId,
          ClassID: this.ClassID,
          ClassName: this.ClassName,
          TimeProgress: this.currentPage,
          Duration: this.pageCount,
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    videoClose() {
      console.log(111, this.videoShow);
      // end 说明调用过结束接口, 没结束退出进度达到95也认为观看完成
      if (this.endtype !== "end") {
        var vdobj = document.getElementById("videoBank"); //获取video对象
        var total = vdobj.duration;
        var tp = localStorage.getItem(this.IdCard + this.VideoId + "remTime");
        var progress = parseInt((Number(tp) / Number(total)) * 100);
        // console.log(1231, vdobj);
        // console.log(111, total);
        // console.log(222, tp);
        // console.log(333, progress);
        if (progress >= 95) {
          var aform = {
            IdCard: this.IdCard,
            ClassID: this.ClassID,
            ClassName: this.ClassName,
            // ClassID: this.ClassInfo ? this.ClassInfo.ClassID : "",
            CourseId: this.CourseId,
            SubjectID: this.QuesID,
            VideoId: this.VideoId,
          };
          this.$store.dispatch("api/AddVideoHistory", aform);
        }
      }
      //保存用户观看的视频进度
      this.AddVideoRecord();
      this.videoSrc = "#";
      clearInterval(this.setIntervalPlay);
      try {
        this.close();
      } catch (e) {
        console.log(1111, e);
      }
      this.videoShow = false;

      var that = this;
      setTimeout(function () {
        that.Refreshing = true;
        that.onRefresh();
      }, 600);
    },
    AddVideoHistory(item, type) {
      this.endtype = type;
      var aform = {
        IdCard: this.IdCard,
        ClassID: this.ClassID,
        ClassName: this.ClassName,
        // ClassID: this.ClassInfo ? this.ClassInfo.ClassID : "",
        CourseId: item.CourseId,
        SubjectID: this.QuesID,
        VideoId: item.VideoId,
      };
      var that = this;
      this.$store
        .dispatch("api/AddVideoHistory", aform)
        .then(() => {
          this.$emit("videoDone");
          that.videoClose();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AddVideoRecord() {
      var vdobj = document.getElementById("videoBank"); //获取video对象
      this.$store
        .dispatch("api/AddVideoRecord", {
          IdCard: this.IdCard,
          VideoId: this.VideoId,
          ClassID: this.ClassID,
          ClassName: this.ClassName,
          TimeProgress: this.endtype == "end" ? parseInt(vdobj.duration) : parseInt(localStorage.getItem(this.IdCard + this.VideoId + "remTime")),
          Duration: parseInt(vdobj.duration),
        })
        .then((res) => {
          console.log(res);
          //清除记录的视频进度
          if (this.endtype == "end") {
            localStorage.setItem(this.IdCard + this.VideoId + "remTime", 0);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    QueBack() {
      this.showQue = false;
    },
    Back() {
      this.$emit("listBack");
    },
    async confirmBJ(row) {
      this.ClassID = row.ClassID;
      this.ClassName = row.ClassName;
      this.queForm.ClassID = row.ClassID;
      this.queForm.ClassName = row.ClassName;

      this.onCancel();
    },
    onCancel() {
      this.showBJ = false;
    },
    playVideo() {
      this.getUserMedia(
        {
          audio: false,
          //摄像头拍摄的区域
          video: {
            width: 500,
            height: 500,
            facingMode: "user",
          } /* 前置优先 */,
        },
        this.success,
        this.error
      );
    },

    // 访问用户媒体设备
    getUserMedia(constrains, success, error) {
      if (navigator.mediaDevices.getUserMedia) {
        //最新标准API
        navigator.mediaDevices.getUserMedia(constrains).then(success).catch(error);
      } else if (navigator.webkitGetUserMedia) {
        //webkit内核浏览器
        navigator.webkitGetUserMedia(constrains).then(success).catch(error);
      } else if (navigator.mozGetUserMedia) {
        //Firefox浏览器
        navagator.mozGetUserMedia(constrains).then(success).catch(error);
      } else if (navigator.getUserMedia) {
        //旧版API
        navigator.getUserMedia(constrains).then(success).catch(error);
      } else {
        this.scanTip = "你的浏览器不支持访问用户媒体设备";
      }
    },

    success(stream) {
      this.streamIns = stream;
      const video = document.getElementById("video");

      // webkit内核浏览器
      this.URL = window.URL || window.webkitURL;
      if ("srcObject" in video) {
        video.srcObject = stream;
      } else {
        video.src = this.URL.createObjectURL(stream);
      }

      // 苹果手机的系统弹框会阻止js的线程的继续执行 手动0.1秒之后自动执行代码
      setTimeout(() => {
        video.play();
        this.initTracker(); // 人脸捕捉
      }, 100);
      this.faceTimeout = setInterval(() => {
        this.facetime += 1;
      }, 1000);
    },

    error(e) {
      console.log(e);
      this.scanTip = "访问用户媒体失败";
    },
    initTracker() {
      this.context = document.getElementById("refCanvas").getContext("2d"); // 画布
      this.canvas = document.getElementById("refCanvas");
      this.tracker = new window.tracking.ObjectTracker("face"); // tracker实例
      this.tracker.setInitialScale(4);
      this.tracker.setStepSize(2); // 设置步长
      this.tracker.setEdgesDensity(0.1);
      try {
        this.trackertask = window.tracking.track("#video", this.tracker); // 开始追踪
      } catch (e) {
        this.scanTip = "访问用户媒体失败，请重试";
      }
      //开始捕捉方法 一直不停的检测人脸直到检测到人脸
      this.tracker.on("track", (e) => {
        //画布描绘之前清空画布
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        if (e.data.length === 0) {
          this.scanTip = "未检测到人脸" + this.facetime + "s";
          if (this.facetime > 30) {
            this.$refs.videoB.pause();
          }
        } else {
          this.facetime = 0;
          e.data.forEach((rect) => {
            //设置canvas 方框的颜色大小
            this.context.strokeStyle = "#42e365";
            this.context.lineWidth = 2;
            this.context.strokeRect(rect.x, rect.y, rect.width, rect.height);
          });
        }
      });
    },
    close() {
      this.context = null;
      this.scanTip = "强制暂停...";
      if (this.streamIns) {
        this.streamIns.enabled = false;
        this.streamIns.getTracks()[0].stop();
        this.streamIns.getVideoTracks()[0].stop();
      }
      if (this.faceTimeout) {
        clearInterval(this.faceTimeout);
        this.facetime = 0;
        this.faceTimeout = null;
      }
      this.streamIns = null;
      this.trackertask.stop();
      this.tracker = null;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .middle-container {
    width: 100%;
    flex: 1;
    overflow-y: hidden;
    padding-bottom: 1rem;
    box-sizing: border-box;
  }
}
.middle-tags {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.captureFrame {
  position: absolute;
  width: 90px;
  height: 160px;
  bottom: 0;
}
.pdf-view {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .pdf-c {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }
}
.pdf-page {
  width: 100%;
  margin: 0.5rem 0;
  display: flex;
  flex-direction: row;
  padding: 0 15%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;

  .turn {
    border: #333333 solid 1px;
    padding: 5px 10px;
    box-sizing: border-box;
  }
}
.tabbar-container {
  width: 100%;
  height: 3rem;
  text-align: center;
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #2d8efc;
  position: relative;
  font-size: 1.1rem;

  .popup-back {
    position: absolute;
    left: 20px;
  }
  .popup-share {
    position: absolute;
    right: 20px;
    top: 1rem;
  }
}

.video-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.face-capture {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  visibility: hidden;
}

.face-capture video,
.face-capture canvas {
  position: fixed;
  bottom: 50px;
  object-fit: cover;
  z-index: 2;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.face-capture .contentp {
  position: fixed;
  bottom: 0;
  font-size: 18px;
  font-weight: 500;
  color: #333333;
}

/deep/ .van-tabs {
  height: 100%;
}
/deep/ .van-tabs__content {
  height: calc(100% - 44px);
}
/deep/ .van-tab__pane {
  height: 100%;
}
</style>
